import styled from 'styled-components';

export const ContainerTermosStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    max-width: 578px;
    margin: 80px 105px 100px;  

    svg.btn-fechar {
        margin: 8px 0 8px 8px;
        cursor: pointer;
        width: 12px;
        height: 12px;

        path {
            fill: #6C757D;
            stroke: #6C757D;
        }
    }

    button#btn-aceite-termos {
        align-self: flex-end;
    }

    @media(min-width: 1920px){
        margin: 140px 264px;
        max-width: 585px;
    }
   
`;

export const TituloStyled = styled.div`
    color: #475466;

    h1 {
        font-weight: 600;
        font-size: 40px;
        line-height: 52px;
        color: inherit;
        margin: 0;
        letter-spacing: -2%;
    }

    p {
        font-size: 12px;
        font-weight: 300;
        line-height: 15px;
        color: inherit;
        margin: 0;
    }
`;

export const HeaderStyled = styled.header`
    display: flex;
    align-items: start;
    justify-content: space-between;
`;

export const BodyStyled = styled.body`
    background-color: #F5F7FA;
    max-height: 437px;
    max-width: 100%;
    overflow-y: scroll !important;
    padding-right: 24px;

    .subtitle{
        color: #6C757D;
        font-size: 12px;
        font-weight: 300;
        line-height: 130%;
        text-align: justify;

        > span {
            display: block;
        }
    }

    @media(min-width: 1920px) {
        max-height: 550px;
    }
`;

export const CondicaoStyled = styled.div`

    margin-bottom: 18px;

    .titulo-condicao{
        margin-bottom: 0;
        font-weight: 400;
    }

    .corpo-condicao {
        font-weight: 300;
        text-align: justify;

        .aviso-privacidade {
            color: #6C757D !important;
            text-decoration: underline;
            font-weight: 400;
        }
    }

    .titulo-condicao, .corpo-condicao {
        font-size: 12px;
        color: #6C757D;
        line-height: 130%;
    }
`;